import { render, staticRenderFns } from "./companyCreate.vue?vue&type=template&id=35f77180&"
import script from "./companyCreate.vue?vue&type=script&lang=js&"
export * from "./companyCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports